import React, { createContext, PropsWithChildren, useContext } from 'react'

import { EasyBuilderCampaignType } from 'shared/api/requests/easyBuilder/types'

interface SidebarContextType {
  campaignType: EasyBuilderCampaignType
  widgetId?: number | null
  flowId?: string
  canAutofocus?: boolean
}

const defaultSidebarContext: SidebarContextType = {
  campaignType: EasyBuilderCampaignType.IG_CGT_REPLY,
  widgetId: null,
  canAutofocus: false,
}

const SidebarContext = createContext<SidebarContextType>(defaultSidebarContext)

export const useSidebarContext = () => {
  return useContext(SidebarContext)
}

export const SidebarContextProvider = ({
  campaignType,
  widgetId,
  flowId,
  canAutofocus = false,
  children,
}: PropsWithChildren<SidebarContextType>) => {
  return (
    <SidebarContext.Provider
      value={{
        campaignType,
        widgetId,
        flowId,
        canAutofocus,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}
